// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_xlsx_mjs":"764ef8d2be24c17d","node_modules_dompurify_dist_purify_js":"7159061b9e1ddfb8","node_modules_canvg_lib_index_es_js":"6c38145f667c3501","node_modules_html2pdf_js_node_modules_dompurify_dist_purify_es_mjs":"2bc648dbe3558bbf"}[chunkId] + ".js";
};